import { createFileRoute } from "@tanstack/react-router";

import { AppShell } from "@/components/app/app-shell";
import { OutreachInbox } from "@/components/app/outreach-inbox";

export const Route = createFileRoute("/_authenticated/t1dwpanel/outreach")({
  head: () => ({
    meta: [
      { title: "Admin inbox | Warrior Volunteer" },
      {
        name: "description",
        content: "Every outreach email and reply across all volunteers, in one shared inbox.",
      },
      { property: "og:title", content: "Admin inbox | Warrior Volunteer" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      {
        property: "og:description",
        content: "Every outreach email and reply across all volunteers, in one shared inbox.",
      },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: AdminOutreachPage,
});

function AdminOutreachPage() {
  return (
    <AppShell eyebrow="Admin" title="Inbox" dense containViewport>
      <OutreachInbox scope="all" />
    </AppShell>
  );
}
